import { InviteProgramStatusEnum } from '@/services/api-clients';

export function inviteProgramStatusIconFilter(type: InviteProgramStatusEnum): string {
    switch(type) {
        case InviteProgramStatusEnum.Upcome: return 'mdi-clock-outline';
        case InviteProgramStatusEnum.Active: return 'mdi-check';
        case InviteProgramStatusEnum.Finished: return 'mdi-send-check';
    }
}